import {User} from '../../incase-domain/user';
import {AuthReducerType, LOGOUT_USER, SET_LOGGED_IN_USER} from '../actions/types/auth.types';

export interface AuthReducerState {
    hasError: boolean;
    loginErrorMessage: string;
    loggedInUser?: User;
    isLoggedIn: boolean;
}

export const preloadedState = {
    hasError: false,
    loginErrorMessage: '',
    isLoggedIn: false,
};

export const authReducer = (state: AuthReducerState = preloadedState, action: AuthReducerType): AuthReducerState => {
    switch (action.type) {
        case SET_LOGGED_IN_USER:
            return {...state, loggedInUser: action.user, isLoggedIn: !!action.user};
        case LOGOUT_USER:
            return {...preloadedState};
        default:
            return state;
    }
};
